import { render, staticRenderFns } from "./10ApplicantInfo.vue?vue&type=template&id=2c73d3d7"
import script from "./10ApplicantInfo.vue?vue&type=script&lang=js"
export * from "./10ApplicantInfo.vue?vue&type=script&lang=js"
import style0 from "./10ApplicantInfo.vue?vue&type=style&index=0&id=2c73d3d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports